module.exports = __webpack_public_path__ + "static/media/havana-12.cd0e22e5.jpg";